// Centralized contact information — change this file to update phone/email/whatsapp/address globally
export const CONTACT = {
  // international phone number (no leading +) for wa.me links
  whatsappNumber: '919759049639',
  // wa.me link (recommended format: without a plus sign)
  whatsappLink: 'https://wa.me/919759049639',
  // tel link uses the plus prefix
  tel: '+919759049639',
  telLink: 'tel:+919759049639',
  // user-facing display phone
  displayPhone: '+91 97590 49639',
  // email
  email: 'PK468080@gmail.com',
  // business name (matches the Google Business Profile)
  businessName: 'Make Mind Automations and Digital Marketing Agency',
  // business address (matches the Google Business Profile)
  address: 'Banwari, New Laxmi Nagar, Police Choki Mohalla, near Small Power House & CKI Chowk, Rampur, Adarsh Nagar, Najibabad, Uttar Pradesh 246763, India'
};

export default CONTACT;
